//let labelListTreeData;
/* 异步加载 一些弹窗组件 */
// const TerrainElevationTree = () => import('./labelListTree/TerrainElevationTree');

/* 引入Mars3d 的 Kml2JsonLayer.js代码 */
import Kml2JsonLayer from "../../../static/js/mars3d/geojson/kml2json/Kml2JsonLayer.js";

//按需加载
import { getKmlInfo } from "../../../api/api";

// import {
// 	EventBus
// } from '../../../static/js/event-bus.js';
import {
  notSimplifyKmlGeoJSON,
  lowSimplifyKmlGeoJSON,
  mediumSimplifyKmlGeoJSON,
  highSimplifyKmlGeoJSON,
} from "@/components/tables/program/map.js";
export default {
  components: {
    // TerrainElevation
  },
  props: {},
  data() {
    return {
      labelList_show: true,

      treeData: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      checkedIds: [], //页面加载时默认勾选的id
      isFold: false,
    };
  },
  mounted() {
    let that = this;
    if (this.$GLOBAL.labelListTree) {
      this.treeData = this.$GLOBAL.labelListTree;
      this.recursionKmlInfo(this.treeData, false);
    } else {
      getKmlInfo({
        projectId: sessionStorage.getItem("nowProjectId"),
      }).then(function(res) {
        let KmlData = res.data.data;
        // console.log(KmlData);
        // console.log(11111111111)
        that.recursionKmlInfo(KmlData);
        that.treeData = that.$GLOBAL.labelListTree;
        // console.log(JSON.parse(JSON.stringify(that.$GLOBAL.labelListTree)));
        // console.log('0000000000000000000');
      });
    }

    setTimeout(function() {
      that.$message({
        message: "文本标注信息加载完毕后，点击弹窗列表项即可定位。",
        type: "success",
        offset: 100,
        showClose: true,
        duration: 3600,
      });
    }, 1000);

    //this.initTreeData();
    // console.log(this.checkedIds);
    // console.log(88888888888888)
  },

  methods: {
    //递归处理文字标注信息树列表
    recursionKmlInfo(data, needCreate = true) {
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.push(item.id);
        if (item.children.length > 0) {
          this.recursionKmlInfo(item.children, needCreate);
        } else {
          //没有子项时做的操作
          if (!item.kmlInfo.type) {
            if (item.kmlInfo.isDisplay) {
              this.checkedIds.push(item.id);
              if (needCreate) {
                if (item.kmlInfo.kmlUrl) {
                  this.createKmlLayer(item);
                }
              }
            }
          } else {
            //为目录
          }
        }
      });
      this.$GLOBAL.labelListTree = data;
      // console.log(labelListTreeData);
      // console.log(33333333333333);
      //return data;
    },
    handleCheck(data, status) {
      //修改节点的选中状态时触发。
    },
    nodeClick(data) {
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(11111111111);
      if (data.kmlLayerId) {
        let getLayer = this.$GLOBAL.map.getLayerById(data.kmlLayerId);
        //console.log(getLayer);
        if (getLayer) {
          getLayer.flyTo({
            duration: 2,
          });
          return false;
        }
      } else {
        this.$alert(
          "该节点尚未被勾选，或者还没有在后台上传该节点对应的文字标注文件。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
      }
    },

    handleCheckChange(data, status) {
      console.log(data);
      if (!data.kmlInfo.type) {
        if (!status) {
          // console.log(this.$GLOBAL.map);
          this.$GLOBAL.map.removeLayer(data.kmlLayerId, true);
          data.kmlInfo.isDisplay = false;
          // console.log(5555555555);
          // let i = 0;
          // for (var k in this.$GLOBAL.map._layerCache) {
          // 	i++;
          // }
          // console.log(i);
        } else {
          // console.log(JSON.parse(JSON.stringify(this.treeData)));
          this.createKmlLayer(data);
          data.kmlInfo.isDisplay = true;
          // console.log(6666666666);
          // console.log(JSON.parse(JSON.stringify(this.treeData)));
        }
      } else {
        //为目录
      }
    },
    createKmlLayer(item) {
      // console.log(JSON.parse(JSON.stringify(item)));
      // console.log(3333333333333);
      // alert(item.kmlInfo.textDistinct);

      //展示数据
      // let kmlLayer = new mars3d.layer.KmlLayer({
      //   url: "/baseIP/" + item.kmlInfo.kmlUrl,
      //   // format:function(val1,val2){
      //   // 	// return '123456';
      //   // 	console.log(val1);
      //   // 	console.log('123456');
      //   // },
      //   symbol: {
      //     styleOptions: {
      //       color: "#00ffff",
      //       opacity: 0.8,
      //       width: 3,
      //       // arcType: Cesium.ArcType.GEODESIC, // 现在已经不需要设置这个参数了。
      //       clampToGround: true,
      //       //visibleDepth: false,
      //       // extrudedHeightReference:Cesium.HeightReference.RELATIVE_TO_GROUND,
      //       //标记文字
      //       label: {
      //         text: "{name}",

      //         horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      //         verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      //         pixelOffsetY: -30,

      //         opacity: 1,
      //         font_size: item.kmlInfo.textSize || 30,
      //         color: item.kmlInfo.textColor || "#ffffff",
      //         // heightReference:Cesium.HeightReference.RELATIVE_TO_GROUND,
      //         font_family: "黑体",
      //         outline: true,
      //         outlineColor: "#000000",
      //         outlineWidth: 3,

      //         scaleByDistance: true,
      //         scaleByDistance_far: 10000,
      //         scaleByDistance_farValue: 0.1,
      //         scaleByDistance_near: 20,
      //         scaleByDistance_nearValue: 1,

      //         distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
      //           0.0,
      //           item.kmlInfo.textDistinct || 20000
      //         ),
      //         clampToGround: true,
      //         //visibleDepth: false,
      //       },
      //       // polygon:{
      //       // 	distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0.0, item.kmlInfo.textDistinct||5000),
      //       // 	clampToGround: true, //贴地
      //       // 	visibleDepth: false,
      //       // },
      //     },
      //   },
      //   popup: "all",
      //   clampToGround: true, //是否贴地
      //   show: true,
      //   hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
      //   zIndex: item.kmlInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
      // });
      let url = this.$GLOBAL.localResourcesPath + item.kmlInfo.kmlUrl;
      let simplifyFunc = notSimplifyKmlGeoJSON;
      if (
        item.kmlInfo?.isOptimization !== undefined &&
        !item.kmlInfo?.isOptimization
      ) {
        simplifyFunc = notSimplifyKmlGeoJSON;
      } else {
        switch (item.kmlInfo?.optimizationDegree) {
          case "low":
            simplifyFunc = lowSimplifyKmlGeoJSON;
            break;
          case "medium":
            simplifyFunc = mediumSimplifyKmlGeoJSON;
            break;
          case "high":
            simplifyFunc = highSimplifyKmlGeoJSON;
            break;
          default:
            simplifyFunc = notSimplifyKmlGeoJSON;
            break;
        }
      }
      let kmlLayer = new mars3d.layer.Kml2JsonLayer({
        //url: "/baseIP/" + item.kmlInfo.kmlUrl,
        url: url,
        format: simplifyFunc,
        symbol: function(attr, style, featue) {
          // featue.geometry.coordinates.forEach((i) => {
          //   i.forEach((j) => {
          //     j[2] = item.kmlInfo.diffHeight; //坐标轴z值
          //   });
          // });
          return {
            fill: item.kmlInfo.fill,
            color: item.kmlInfo.areaColor,
            opacity: item.kmlInfo.transparency || 0.5,
            outline: item.kmlInfo.outLine || true,
            outlineColor: item.kmlInfo.areaSideColor,
            outlineWidth: 3,
            width: 3,
            // arcType: Cesium.ArcType.GEODESIC,
            // 标记文字
            clampToGround: item.kmlInfo.clampToGround,
            //visibleDepth: false,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: item.kmlInfo.textDistinct || 1000000,
            distanceDisplayCondition_near: 0,
            // diffHeight: item.kmlInfo.diffHeight,
            label: {
              text: "{name}",
              //text: item.kmlInfo.kmlName,//不应该这样写，因此让程序自己去解析文件里的name。
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffsetY: -10,
              opacity: 1,
              font_size: item.kmlInfo.textSize || 26,
              color: item.kmlInfo.textColor || "#ffffff",
              font_family: item.kmlInfo.fontStyle || "黑体",
              outline: true,
              outlineColor: item.kmlInfo.sideColor || "#000000",
              outlineWidth: 3,
              scaleByDistance: true,
              scaleByDistance_far: 10000,
              scaleByDistance_farValue: 0.1,
              scaleByDistance_near: 20,
              scaleByDistance_nearValue: 1,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                0.0,
                item.kmlInfo.textDistinct || 20000
              ),
              clampToGround: item.kmlInfo.clampToGround, //不贴地
              // visibleDepth: false,
            },

            // polygon: {
            //   distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            //     0.0,
            //     item.kmlInfo.textDistinct || 20000
            //   ),
            //   visibleDepth: false,
            //   clampToGround: false, //不贴地
            // },
          };
        },
        // center: { lat: 31.653222, lng: 117.273592, alt: 35183, heading: 358, pitch: -63 },
        popup: "all",
        flyTo: true,
        clampToGround: true, //是否贴地
        // visibleDepth: false, //避免文字被遮挡
        show: true,
        // // "tooltip": "{name}",
        hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
        zIndex: item.kmlInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
      });
      this.$GLOBAL.map.addLayer(kmlLayer);

      item.kmlLayerId = kmlLayer.id;
    },
    labelList_click() {
      this.$emit("labelListBox_close");
    },
    // test(){
    // 	console.log(2)
    // }
  },
  watch: {},
  destroyed() {
    this.$GLOBAL.labelListTree = this.treeData;
    // console.log(JSON.parse(JSON.stringify(this.treeData)));
    // console.log(11111111111111);
  },
};
//console.log(localStorage.getItem(ColorPicker));
